<template lang="pug">
    v-dialog.modal(v-model="showMe" width="600" @keydown.escape="showMe = false")
        v-toolbar.title.font-weight-bold(:color="color" dark)
            |   {{title}}
        v-card
            v-container     
                v-layout(row wrap)
                    v-flex.xs12
                        slot(name="top-slot")
                    v-flex(xs12).mb-4
                        slot(name="content")
                    v-flex(xs12).mb-4.input-container
                        v-form(ref="form")
                            v-text-field.text-xs-center.password-input.display-1(
                                ref="authcode" 
                                :rules="rules" 
                                mask="###" 
                                v-model="code" 
                                outline 
                                full-width 
                                maxlength="3" 
                                type="password"
                                @keydown.enter="handle($event)"
                                :label="codeLabel"
                                ) 
                    v-flex(xs6).px-3
                        v-btn(
                          color="success"
                          @click="handleSubmit()"
                          :disabled="disabled"
                          block
                          large) Autorizar
                    v-flex(xs6).px-3
                        v-btn(ref="authbutton" color="warning" @click="showMe = false" block outline large) Cancelar
</template>

<script>
import InputValidation from '@/mixins/InputValidations.js'
export default {
    name: 'auth-modal',
    props: {
        /**
         * @description
         */
        value: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         */
        color: {
            type: String,
            default: () => 'primary',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: () => 'Código de Vendedor',
        },
        codeLabel: {
            type: String,
            default: '',
        },
    },
    data: function() {
        return {
            code: '',
            rules: [
                // FIXME: Uncomment rule on production
                // value => (value.length < 3 ? 'debe ingresar 3 dígitos' : true),
            ],
        }
    },
    computed: {
        showMe: {
            get: function() {
                return this.value
            },
            set: function(boolean) {
                this.$emit('input', boolean)
            },
        },
    },
    methods: {
        handleSubmit: function() {
            if (!this.$refs.form.validate()) return this.handleFocus('authcode')
            this.$emit('submit', this.code)
        },
        handleFocus: function(ref) {
            this.$nextTick(() => this.$refs[ref].focus())
        },
        handle: function(e) {
            if (this.disabled) return
            e.preventDefault()
            e.stopPropagation()
            this.handleSubmit()
        },
    },
    watch: {
        /**
         * @description
         */
        value: function(newVal, oldVal) {
            if (newVal) {
                this.handleFocus('authcode')
            }
        },
    },
    components: {},
    mixins: [InputValidation],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    beforeUpdate: function() {
        if (!this.value) this.code = ''
    },
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.password-input {
    overflow: hidden;
    max-width: 120px;
    min-width: 140px;
    max-height: 100px;
}
.input-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>
